import * as React from 'react';
import classnames from 'classnames';
import { ProductDetailReviewsView } from '@grandvisionhq/fun-products';
import { useReviewsContext } from '@grandvisionhq/reviews';
import { useIntl } from '@grandvisionhq/state';
import { UserReviewsDisplay } from '../UserReviewsDisplay/UserReviewsDisplay.js';

const ProductDetailReviewsDrawerContainer = ({ className  })=>{
    const { reviewCount  } = useReviewsContext();
    const { getLabel  } = useIntl();
    const title = getLabel('reviews.drawer.button.title');
    if (!reviewCount) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("section", {
        className: classnames('product-detail-reviews', className),
        "aria-label": title,
        "data-t": "product-detail-reviews"
    }, /*#__PURE__*/ React.createElement(ProductDetailReviewsView, {
        title: title
    }, /*#__PURE__*/ React.createElement(UserReviewsDisplay, {
        isSingleColumn: true
    })));
};

export { ProductDetailReviewsDrawerContainer };
//# sourceMappingURL=ProductDetailReviewsDrawerContainer.js.map
